import React from 'react';

const SlideThree = () => {
	return <div>SlideThree</div>;
};

export default SlideThree;
